import {
    errorMessageTypes,
    stepTypes,
} from '../../actions/IdVerificationActions';

import sessionReader from '../../store/readHelpers/SessionReader';

const capturedPhotoCheckpointSelector = {
    selectCheckpoint(verificationStatus) {
        switch (verificationStatus) {
        case null:
            return {};

        case errorMessageTypes.loading:
            return {
                loading: true,
                status: verificationStatus,
            };

        case errorMessageTypes.none:
            return {
                successful: true,
                status: verificationStatus,
            };

        default:
            return {
                successful: false,
                status: verificationStatus,
            };
        }
    },

    selectShowRelaxedButton(currentStep) {
        return (
            sessionReader.isRelaxedAutomaticIdVerificationEnabled()
            && currentStep === stepTypes.ID_CARD
        );
    },

    mapStateToProps({ idverification }) {
        const { currentStep, verificationStatus } = idverification;
        const checkpointProps = this.selectCheckpoint(verificationStatus);

        return {
            ...checkpointProps,
            showRelaxedButton: this.selectShowRelaxedButton(currentStep),
        };
    },
};

export default capturedPhotoCheckpointSelector;
